import { getMomentDate } from "utils/commonUtils";
import BaseModel from "./BaseModel";

export default class WhitelistIp extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || '';
        this.ip = data.ip || undefined;
        this.isDeleted = data.isDeleted;
        this.name = data.name || '';
        this.url = data.url || '';
        this.propertyId = data.propertyId || '';
        this.propertyName = data.propertyName || '';
    }

    export() {
        return {
            id: this.id,
            ip: this.ip,
            isDeleted: this.isDeleted,
            name: this.name,
            url: this.url,
            propertyId: this.propertyId,
            propertyName: this.propertyName,
        }
    }

    exportUpdateConfig() {
        return {
            id: this.id,
            ip: this.ip,
            isDeleted: this.isDeleted,
            name: this.name,
            url: this.url,
            propertyId: this.propertyId,
            propertyName: this.propertyName,
      }
    }

}
